import { TechnologyOriginsSankeyTile } from '@components/shared/technology-origins-sankey.component';
import { useGetTechnology } from '@queries/technology.query';
import { useGetCurrentUser } from '@queries/users.query';
import { isChildOrganizationView as getIsChildOrganizationView } from '@utils/parent-organization.util';
import { TechnologyHeaderTab } from '@utils/query-state.util';
import { FC } from 'react';
import { ProductsCompact } from './products-compact.component';
import { ReadinessSummary } from './readiness-summary.component';
import { ResearchCompact } from './research-compact.component';
import { TechnologyTabLayout } from './shared/technology-tab-layout.component';
import { TechnologyDetailsTile } from './technology-details-tile.component';
import { TechnologyOrganizationTile } from './technology-organization-tile.component';
import { TrlSummaryWrapper } from './trl-summary-wrapper.component';
import { UsesSubsystemsCompact } from './uses-subsystems-compact.component';

const SANKEY_MAX_HEIGHT = 600;

type TechnologyOverviewTabProps = {
  onNavigateToTab?: (tab: TechnologyHeaderTab) => void;
  technologyId?: string;
};

export const TechnologyOverviewTab: FC<TechnologyOverviewTabProps> = (props) => {
  const { onNavigateToTab, technologyId } = props;
  const { data: technology, isPending: isTechnologyLoading } = useGetTechnology(technologyId);
  const { isInnovator, isSelectedCompanyParentOrganization, selectedCompany } = useGetCurrentUser();

  const isChildOrganizationView = getIsChildOrganizationView({
    isSelectedCompanyParentOrganization,
    selectedCompanyId: selectedCompany?.id,
    technologyCompanyId: technology?.company?.id,
  });
  const navigateHandler = isChildOrganizationView ? undefined : onNavigateToTab;

  const sidebarContent = (
    <>
      <TechnologyDetailsTile />
      {!isInnovator && (
        <TechnologyOrganizationTile
          company={technology?.company}
          isLoading={isTechnologyLoading}
          onNavigateToTab={navigateHandler}
        />
      )}
      <ResearchCompact onNavigateToDetails={navigateHandler} />
      <UsesSubsystemsCompact onNavigateToDetails={navigateHandler} />
      <ProductsCompact onNavigateToDetails={navigateHandler} />
      <ReadinessSummary onNavigateToTab={navigateHandler} />
      <TrlSummaryWrapper onNavigateToTab={navigateHandler} />
    </>
  );

  const mainContent = (
    <TechnologyOriginsSankeyTile
      sankeyProps={{ maxHeight: SANKEY_MAX_HEIGHT }}
      technologyId={technologyId}
    />
  );

  return (
    <TechnologyTabLayout
      className="flex-col items-stretch @min-[56.25rem]/technology:flex-row @min-[56.25rem]/technology:items-start"
      mainContent={mainContent}
      sidebar={sidebarContent}
      sidebarClassName="w-full @min-[56.25rem]/technology:w-80 2xl:w-96"
      variant="content-content"
    />
  );
};
